import { createSelector } from 'reselect';
import { isBookedOrConfirmed } from '../order/selectors';
var getState = function (state) { return state.formIsLocked; };
export var isFormLocked = createSelector(getState, isBookedOrConfirmed, function (isLocked, isBooked) { return isLocked && !isBooked; });
